import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEn from "./locales/en/translation.json";
import translationHy from "./locales/hy/translation.json";

const savedLanguage = localStorage.getItem("lang");

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: translationEn },
        hy: { translation: translationHy }
    },

    lng: savedLanguage || "en",   
    fallbackLng: "en",

    interpolation: {
        escapeValue: false
    }
});

export default i18n;